'use client';

import {
    AccountSwitcherSheet,
    BottomNavigation,
    GoogleTagManagerNoScript,
    Navbar,
    PopupsModal,
    UpdateAnnouncementModal
} from '@insta-club/components';
import PWAInstallModal from '@insta-club/components/common/PwaInstallModal';
import { DailyVisitProvider } from '@insta-club/context';
import NextTopLoader from 'nextjs-toploader';
import { Toaster } from 'react-hot-toast';
import { Drawer } from 'src/libs/components/layout/Drawer';

export default function Providers({ children }: { children: React.ReactNode }) {
    return (
        <>
            <NextTopLoader
                showSpinner={false}
                color='#292960'
                initialPosition={0.08}
                crawlSpeed={200}
                height={3}
                crawl={true}
                easing='ease'
                speed={200}
            />
            <GoogleTagManagerNoScript />
            <Navbar />
            <DailyVisitProvider>{children}</DailyVisitProvider>
            <Drawer />
            <BottomNavigation />
            <AccountSwitcherSheet />
            <Toaster />
            <UpdateAnnouncementModal />
            <PopupsModal />
            <PWAInstallModal />
        </>
    );
}

